import { render } from "./SelecaoMotivoMultiple.vue?vue&type=template&id=37ceacca&scoped=true"
import script from "./SelecaoMotivoMultiple.vue?vue&type=script&lang=js"
export * from "./SelecaoMotivoMultiple.vue?vue&type=script&lang=js"

import "./SelecaoMotivoMultiple.vue?vue&type=style&index=0&id=37ceacca&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ceacca"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip,QInput});
